import Vue from "vue";
import Vuex from "vuex";
import blocksBuild from "./modules/blocks-build";
import { bot } from "./modules/bot";
import { campaigns } from "./modules/campaign";
import { cards } from "./modules/cards";
import { chatHistory } from "./modules/chat-history";
import { core } from "./modules/core";
import llm from "./modules/llm/index";
import nlp from "./modules/nlp/index";
import { settings } from "./modules/settings";
import { user } from "./modules/user";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    bot,
    core,
    blocksBuild,
    cards,
    nlp,
    llm,
    settings,
    chatHistory,
    campaigns,
  },
});

export default store;
